import { ResetButton } from 'components/common-form/components/ResetButton';
import type { FatalErrorProps } from 'components/FatalError/FatalError';
import { FatalError } from 'components/FatalError/FatalError';
import { FC } from 'react';

type Props = { onRetry?: () => void };

export const TabFatalError: FC<Props & Omit<FatalErrorProps, 'children'>> = ({
  onRetry,
  titleKey,
  title,
  detailsKey,
  details,
}) => {
  return (
    <div className="d-flex bg-lvl3 w-100 h-100 justify-content-center align-items-center">
      <FatalError
        titleKey={titleKey ?? 'errorForm.title'}
        detailsKey={detailsKey ?? 'errorForm.details'}
        title={title}
        details={details}
      >
        {onRetry && (
          <div>
            <ResetButton className="btn-default mt-3" onResetClicked={onRetry} isEnabled />
          </div>
        )}
      </FatalError>
    </div>
  );
};
